import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdminComponent} from './layout/admin/admin.component';
import {TempBasicComponent} from './layout/temp-basic/temp-basic.component';

const routes: Routes = [
   {
      path: '',
      component: AdminComponent,
      children: [
         {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full'
         },
         {
            path: 'home',
            loadChildren: './appbago/home/home.module#HomeModule',
            data: {
               title: 'Home',
               status: false,
            }
         },
         {
            path: 'comercial',
            loadChildren: './appbago/comercial/comercial.module#ComercialModule',
         },
         {
            path: 'compras',
            loadChildren: './appbago/compras/compras.module#ComprasModule',
         },
         {
            path: 'ficecmodulo',
            loadChildren: './appbago/ficecmodulo/ficecmodulo.module#FicecmoduloModule'
         },
         {
            path: 'formatosinversion',
            loadChildren: './appbago/formatos-inversion/formatos-inversion.module#FormatosInversionModule'
         },
         {
            path: 'reembolsogastos',
            loadChildren: './appbago/reembolsogastos/reembolsogastos.module#ReembolsoGastosModule'
         },
         {
            path: 'reportemm',
            loadChildren: './appbago/reportemm/reportemm.module#ReportemmModule'
         },
         {
            path: 'segmodulo',
            loadChildren: './appbago/segmodulo/segmodulo.module#SegModuloModule'
         },
         {
            path: 'kam',
            loadChildren: './appbago/ficha-kam/ficha-kam.module#FichaKamModule'
         },
         {
            path: 'cuentasclave',
            loadChildren: './appbago/cuentas-clave/cuentas-clave.module#CuentasClaveModule'
         },
         {
            path: 'zonales',
            loadChildren: './appbago/zonales/zonales.module#ZonalesModule'
         },
         {
            path: 'aplicaciones',
            loadChildren: './appbago/aplicaciones-externas/aplicaciones-externas.module#AplicacionesExternasModule'
         },
         {
            path: 'mantenimiento',
            loadChildren: './appbago/mantenimiento/mantenimiento.module#MantenimientoModule'
         },
         {
            path: 'plancelular',
            loadChildren: './appbago/plan-celular/plan-celular.module#PlanCelularModule'
         },
         {
            path: 'aso-service',
            loadChildren: './appbago/aso-service/aso-service.module#AsoServiceModule'
         },
      ]
   },
   {
      path: '',
      children: [
         {
            path: 'seguridad',
            loadChildren: './appbago/seguridad/seguridad.module#SeguridadModule'
         },
      ]
   },
   {
      path: '',
      component: TempBasicComponent,
      children: [
         {
            path: 'reportes',
            loadChildren: './appbago/reportes/reportes.module#ReportesModule'
         },
      ]
   }
];

@NgModule({
   // imports: [RouterModule.forRoot(routes)],
   imports: [RouterModule.forRoot(routes, {useHash: true})],
   exports: [RouterModule]
})
export class AppRoutingModule {
}
